module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Price2-58a2122f4ad77cef28fb0ce394dd2b64.svg";